;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.LeaguesRegeneration = function() {

	};

	_.extend(Controller.LeaguesRegeneration.prototype, {
		start: function (league_id) {
			this.view = new Layout.RightSidebar();

			APP.main.show(this.view);

			this.layout = new Layout.LeaguesRegenerationRegions();

			this.view.main.show(this.layout);

			this.getJSONData();

			this.user  = APP.module('instance').user;

			this.share = new Model.Share();

			this.view.aside.show(this.getWidgets(league_id));

			this.layout.stepsProgress.show(new View.LeaguesRegenerationStepsBar());

		},
		index: function() {
			this.start();
			this.updateStepBar('select');
			var leaguesList = new View.LeaguesRegenerationList({
				model:   new Backbone.Model(),
				leagues: new Collection.LeaguesRegeneration(),
				share:   this.share,
				rounds:  this.rounds,
				user:    this.user
			});

			this.layout.stepHolder.show(leaguesList);
			return this;
		},
		settings: function(league_id) {
			this.start(league_id);
			this.updateStepBar('settings');
			var leaguesSettings = new View.LeaguesRegenerationSettings({
				league_id: +league_id,
				model:     new Backbone.Model(),
				league:    new Model.LeagueRegeneration(),
				rounds:    this.rounds,
				user:      this.user
			});

			//leaguesSettings.on('leagues:view:menu', _.bind(this.leaguesViewMenu, this));
			leaguesSettings.on('leagues_regenerate:create', this.navigateToInvites);
			this.layout.stepHolder.show(leaguesSettings);

			return this;
		},
		invites: function(league_id, regenerated_id) {
			this.start(league_id);
			this.updateStepBar('invites');
			var leaguesInvites        = new View.LeaguesRegenerationInvites({
				league_id: 		+regenerated_id,
				invites_id : 	+league_id,
				model:     		new Backbone.Model(),
				league:    		new Model.LeagueRegeneration(),
				//invites_league: new Model.LeagueRegeneration(),
				share:    		this.share,
				invites:   		_.findWhere($.jStorage.get('users_from_regenerated'), {id:+league_id}),
				user:      		this.user
			});
			$.jStorage.deleteKey('users_from_regenerated');
			leaguesInvites.on('leagues_invites:success', this.navigateToConfirm);
			this.layout.stepHolder.show(leaguesInvites);
			return this;
		},
		confirmation: function(league_id, regenerated_id) {
			this.start(league_id);
			this.updateStepBar('confirmation');
			var leaguesConfirm        = new View.LeaguesRegenerationConfirm({
				league_id: 		+regenerated_id,
				from_id : 		+league_id,
				model:     		new Backbone.Model(),
				league:    		new Model.LeagueRegeneration(),
				from_league: new Model.LeagueRegeneration(),
				user:      		this.user
			});
			this.layout.stepHolder.show(leaguesConfirm);
			return this;
		},
		getJSONData: function() {
			this.rounds = new Collection.Rounds();
			this.squads = new Collection.Squads();
		},
		getWidgets: function() {
			return new Layout.Sidebar({
				widgets_list: ['Promo', 'RoundTipsStat' , 'Promo'],
				widgets_options: {
					rounds:     this.rounds,
					squads:     this.squads,
					collection: new Collection.TippingRoundStats(),
					model:      new Backbone.Model
				}
			});
		},
		updateStepBar: function(name){
			APP.vent.trigger('step_bar:update', name);
		},
		navigateToInvites: function(league_id, regenerated_league_id) {
			Backbone.history.navigate('regeneration/' + league_id + '/' + regenerated_league_id + '/invites', {trigger: true});
		},
		navigateToConfirm : function(league_id, regenerated_league_id){
			Backbone.history.navigate('regeneration/' + league_id + '/' + regenerated_league_id + '/confirmation', {trigger: true});
		}
	});

	APP.on('start', function() {
		var controller = new Controller.LeaguesRegeneration();
		new Router.LeaguesRegeneration({ controller: controller });
	});

}(window, APP, Backbone, Marionette, $, _));